/**
 * Date utilities with i18n support
 */

import { formatDistanceToNow as dateFnsFormatDistanceToNow } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import i18n from '../../i18n/i18n';

/**
 * Get the appropriate date-fns locale based on current i18n language
 */
const getDateFnsLocale = () => {
  const currentLanguage = i18n.language;

  // Map i18n language codes to date-fns locales
  switch (currentLanguage) {
    case 'de':
      return de;
    case 'en':
      return enUS;
    default:
      return de; // Fallback to German (project default)
  }
};

/**
 * Format distance from now with automatic locale detection from i18n
 */
export const formatDistanceToNow = (date: Date, options?: { addSuffix?: boolean }): string => {
  return dateFnsFormatDistanceToNow(date, {
    ...options,
    locale: getDateFnsLocale(),
  });
};